var _rect, _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 164,
    viewBox: "0 0 256 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 164,
    rx: 37,
    transform: "matrix(-1 0 0 1 256 0)",
    fill: "white",
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.582 80.1395L122.601 64.5981C122.297 64.3872 121.92 64.2443 121.511 64.1859C121.103 64.1274 120.68 64.1558 120.293 64.2678C119.911 64.3867 119.585 64.5867 119.357 64.8425C119.128 65.0983 119.007 65.3986 119.008 65.7054V96.7883C119.007 97.0951 119.128 97.3954 119.357 97.6512C119.585 97.907 119.911 98.107 120.293 98.2259C120.552 98.302 120.827 98.3415 121.106 98.3424C121.663 98.3407 122.198 98.1808 122.601 97.8956L143.582 82.3542C143.976 82.0595 144.197 81.6616 144.197 81.2468C144.197 80.8321 143.976 80.4342 143.582 80.1395Z",
    fill: "#0d99ff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 43,
    transform: "matrix(-1 0 0 1 129.5 81.5)",
    stroke: "#0d99ff",
    strokeWidth: 7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlay);
export default __webpack_public_path__ + "static/media/icon-play.f825f045.svg";
export { ForwardRef as ReactComponent };